import * as React from 'react';

type ILockIconProps = React.SVGProps<SVGSVGElement>;

const LockIcon: React.FunctionComponent<ILockIconProps> = ({
  width = 24,
  height = 24,
  color = '#094FFE',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 37 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12.3462 13.4615V11.3462C12.3462 9.66305 13.0148 8.04888 14.2049 6.85875C15.395 5.66861 17.0092 5 18.6923 5C20.3754 5 21.9896 5.66861 23.1797 6.85875C24.3699 8.04888 25.0385 9.66305 25.0385 11.3462V13.4615M7.05769 13.4615C6.77717 13.4615 6.50815 13.573 6.30979 13.7713C6.11144 13.9697 6 14.2387 6 14.5192V28.7981C6 30.7971 7.70288 32.5 9.70192 32.5H27.6827C29.6817 32.5 31.3846 30.8797 31.3846 28.8807V14.5192C31.3846 14.2387 31.2732 13.9697 31.0748 13.7713C30.8765 13.573 30.6074 13.4615 30.3269 13.4615H7.05769Z'
        stroke={color}
        strokeWidth='2.11538'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default LockIcon;
